import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useAppRouter = (): void => {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "undefined") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search + location.hash,
        page_search: location.search,
        page_hash: location.hash,
      });
    }
  }, [location]);
};
